<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <div *ngIf="processConfig?.optionalExternalEval then thenBlock; else elseBlock">
            </div>
            <ng-template #thenBlock>
                <ion-label style="margin-left: 15%"
                           class="ion-text-center"
                           text-wrap
                           color="primary">
                    {{
                        getText(processConfig?.globalizationConfig, 'title') | uppercase
                    }}
                </ion-label>
                <ion-button
                        text-wrap
                        mode="ios"
                        color="primary"
                        (click)="requestExternalEvaluation()">
                    {{ 'externalEvaluation.requestEval' | translate }}
                </ion-button>
            </ng-template>
            <ng-template #elseBlock>
                <ion-label class="ion-text-center ion-text-wrap">
                    {{
                        getText(processConfig?.globalizationConfig, 'title') | uppercase
                    }}
                </ion-label>
            </ng-template>
        </ion-item>

        <app-step-description
                [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
                [extraDescription]="'freeEvaluationMidYear.selectUser' | translate"
        ></app-step-description>

        <ion-item lines="none" mode="ios" class="para-content">
            <ion-grid>
                <ion-row *ngIf="processConfig && varIsAvailable">
                    <ion-col size-xs="1" size-sm="1" size-md="1">
                    </ion-col>
                    <ion-col size-xs="10" size-sm="10" size-md="10" style="text-align: justify">
                        <ion-label class="evaluation-open" color="primary">
                            {{ 'freeEvaluationMidYear.midYearEvaluationOpen' | translate }}
                        </ion-label>
                        <div class="centralize-div">
                            <p class="para process-description">
                                <span [innerHTML]="'freeEvaluationMidYear.isOpenUntil' | translate"></span> <b> {{ processConfig?.endDate }}</b>.
                            </p>
                        </div>
                        <p class="para process-description">
                            <span [innerHTML]="'freeEvaluationMidYear.openAlert' | translate"></span>
                        </p>
                    </ion-col>
                    <ion-col size-xs="1" size-sm="1" size-md="1">
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="processConfig && !varIsAvailable" class="centralize">
                    <ion-col size-xs="12" size-md="12">
                        <ion-label *ngIf="processWillOpen" text-wrap color="danger">
                            {{ 'freeEvaluationMidYear.evaluationWillOpen' | translate }} {{ processConfig?.startDate }}
                        </ion-label>
                        <ion-label *ngIf="processIsClosed" text-wrap color="danger">
                            {{ 'freeEvaluationMidYear.evaluationIsClosed' | translate }} {{ processConfig?.endDate }}.
                            <br/>
                            {{ 'freeEvaluationMidYear.evaluationIsClosedCannotSend' | translate }}
                        </ion-label>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
        <ion-card mode="ios" class="card-table-data">
            <ng-container *ngIf="canAddEvaluation && processConfig">
                <ion-card-header>
                    <ion-col size="10">
                        <ion-searchbar
                                mode="ios"
                                #userSearch
                                class="section-search-custom"
                                [placeholder]="'generic.searchByName' | translate">
                        </ion-searchbar>
                    </ion-col>
                    <ion-col size="2">
                        <div class="btn-group">
                            <ion-button text-wrap mode="ios" expand="block" slot="end"
                                        (click)="updateSearch(userSearch.value)">
                                {{ 'generic.ThreeSixtyEvaluationValidationGetUsers' | translate }}
                            </ion-button>
                        </div>
                    </ion-col>
                </ion-card-header>

                <div class="selecteds">
                    <b>
                        {{ 'generic.selecteds' | translate }}: <span class="background">{{ evaluations.length }}</span>
                    </b>
                </div>
                <ion-list class="users">
                    <ion-item *ngFor="let user of users" [color]="user.flags?.length > 0 ? 'danger' : '' ">
                        <p class="user" (click)="setUser(user, processConfig)">
                            <b>{{ user.name }}</b> {{ user.qualifier }}<br/>
                           <span class="hoverable"> 
                                ({{ user.flags?.includes('Cycles.UserNotInCycle') ? ('Cycles.UserNotInCycle' | 
                                translate) : ('freeEvaluationMidYear.clickToEvaluate' | translate | lowercase) }})               
                            </span>
                        </p>
                    </ion-item>
                </ion-list>
            </ng-container>

            <app-free-evaluation-users-list
                    [users]="users"
                    [evaluations]="evaluations"
                    [freeEvaluationType]="FreeEvaluationType.MidYear"
                    [canReopenOrDeleteEvaluation]="canReopenOrDeleteEvaluation"
                    [processConfig]="processConfig"
                    [status]="status"
                    (confirmDeleteEvaluationFunction)="confirmDeleteEvaluation($event)"
                    (editEvaluationFunction)="editEvaluation($event)"
                    (reopenEvaluationFunction)="reopenEvaluation($event)"
                    (sendEvaluationFunction)="confirmSendEvaluation($event)">
            </app-free-evaluation-users-list>
        </ion-card>

        <ng-container *ngIf="evaluations.length > 0 && processConfig && varIsAvailable">
            <div class="send-all-evaluations">
                <ion-button mode="ios" expand="block"
                            [disabled]="evaluations.length === 0"
                            (click)="confirmSendEvaluations(evaluations)"
                            style="width: min-content">
                    <span class="bp-send"></span>
                    &nbsp;
                    <span>{{ 'freeEvaluation.sendMidYearEvaluation' | translate }}</span>
                </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>
